import { PartnerType } from '@retailer-platform/dashboard/utils'
import { AccessControl } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const accountManagementPartnerAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ManageUsers],
  partnerTypes: AccessControl.oneOf([
    PartnerType.IDP,
    PartnerType.Retailer,
    PartnerType.VirtualPartner,
  ]),
  restrictedBannersAllowed: true,
}
